/* Sticky mobile order bar for the Product Configurator (Sept 2026).
   Below 990px the order summary sits under the whole configurator, so this bar
   keeps the live total and the next action on screen:
     - before the configurator:  "From $X" starting price + "Start your order" (scrolls to step 1)
     - while configuring:        live total + "Add to cart" (clicks the real button)
     - quote selections (Other): "Get a quote" (scrolls to the quote form)
   It hides itself while the real order card is on screen. Desktop is untouched. */
(function () {
  var MQ = window.matchMedia('(max-width: 989px)');

  /* Cheapest price on this page's linked product, e.g. "From $136".
     Uses available variants first, falls back to all variants. (Oct 2026) */
  function startingPrice(section) {
    try {
      var el = section.querySelector('[data-pc-variants]');
      if (!el) return '';
      var variants = JSON.parse(el.textContent);
      function lowest(list) {
        var min = null;
        list.forEach(function (v) {
          if (typeof v.price === 'number' && v.price > 0 && (min === null || v.price < min)) min = v.price;
        });
        return min;
      }
      var min = lowest(variants.filter(function (v) { return v.available !== false; }));
      if (min === null) min = lowest(variants);
      if (min === null) return '';
      var dollars = min / 100;
      return 'From $' + (Math.round(min) % 100 !== 0 ? dollars.toFixed(2) : dollars.toFixed(0));
    } catch (e) { return ''; }
  }

  function init() {
    var section = document.querySelector('.pc-section');
    if (!section || document.querySelector('.mob-order-bar')) return;
    var form = section.querySelector('[data-pc-form]');
    var addBtn = section.querySelector('[data-pc-add-to-cart]');
    var firstStep = section.querySelector('.pc-configurator .pc-step, .pc-configurator');
    if (!form || !addBtn || !firstStep) return;

    var priceEl = section.querySelector('[data-pc-selected-price]');
    var perEl = section.querySelector('[data-pc-selected-per]');
    var labelEl = section.querySelector('[data-pc-add-label]');
    var orderCard = addBtn.closest('.pc-card') || addBtn;
    var fromPrice = startingPrice(section);

    var bar = document.createElement('div');
    bar.className = 'mob-order-bar';
    bar.setAttribute('hidden', '');
    bar.innerHTML =
      '<div class="mob-order-bar__info">' +
        '<div class="mob-order-bar__label">Your order</div>' +
        '<div class="mob-order-bar__total"></div>' +
        '<div class="mob-order-bar__per"></div>' +
      '</div>' +
      '<button type="button" class="mob-order-bar__btn"></button>';
    document.body.appendChild(bar);

    var totalOut = bar.querySelector('.mob-order-bar__total');
    var perOut = bar.querySelector('.mob-order-bar__per');
    var labelOut = bar.querySelector('.mob-order-bar__label');
    var btn = bar.querySelector('.mob-order-bar__btn');
    var mode = 'start';
    var cardVisible = false;

    function scrollToEl(el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function quoteTarget() {
      var qf = section.querySelector('[data-pc-quote-form]:not([hidden])');
      if (qf) return qf;
      var cta = section.querySelector('[data-pc-quote-cta]:not([hidden])');
      return cta || orderCard;
    }

    function update() {
      if (!MQ.matches) { bar.setAttribute('hidden', ''); document.body.classList.remove('has-mob-order-bar'); return; }
      document.body.classList.add('has-mob-order-bar');

      var beforeConfigurator = firstStep.getBoundingClientRect().top > window.innerHeight * 0.6;
      var quoteMode = addBtn.hidden;

      if (beforeConfigurator) {
        mode = 'start';
        labelOut.textContent = 'Order online';
        totalOut.textContent = fromPrice || 'Instant price';
        perOut.textContent = fromPrice ? 'Excl. GST, free proof' : 'Free proof before we print';
        btn.textContent = 'Start your order';
        btn.disabled = false;
      } else if (quoteMode) {
        mode = 'quote';
        labelOut.textContent = 'Custom order';
        totalOut.textContent = 'Quoted';
        perOut.textContent = "We'll reply within one business day";
        btn.textContent = 'Get a quote';
        btn.disabled = false;
      } else {
        mode = 'add';
        labelOut.textContent = 'Your order';
        totalOut.textContent = priceEl ? priceEl.textContent : '';
        perOut.textContent = perEl ? perEl.textContent : '';
        btn.textContent = labelEl ? labelEl.textContent : 'Add to Cart';
        btn.disabled = addBtn.disabled;
      }

      if (cardVisible) bar.setAttribute('hidden', '');
      else bar.removeAttribute('hidden');
    }

    btn.addEventListener('click', function () {
      if (mode === 'start') scrollToEl(firstStep);
      else if (mode === 'quote') scrollToEl(quoteTarget());
      else if (!addBtn.disabled) addBtn.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        cardVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 }).observe(orderCard);
    }

    new MutationObserver(update).observe(section, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['hidden', 'disabled', 'class']
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    if (MQ.addEventListener) MQ.addEventListener('change', update);
    section.addEventListener('click', function () { setTimeout(update, 0); });

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Cart icon bridge (Oct 2026). The custom order boxes (product-configurator.js and
   product-layout.js) add to the cart with /cart/add.js and then fire 'cart:refresh',
   which the theme does not listen for, so the header cart bubble never updated.
   This re-sends it as the theme's standard cart update event, so the cart icon
   (and cart drawer, if auto-open is on) update straight away. The event class is
   loaded through a small inline module, because this file is minified as a classic
   script and dynamic import() does not survive that. */
(function () {
  var ready = new Promise(function (resolve) { window.__mpCartEventReady = resolve; });
  var loader = document.createElement('script');
  loader.type = 'module';
  loader.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__mpCartEventReady(CartLinesUpdateEvent);";
  document.head.appendChild(loader);

  document.addEventListener('cart:refresh', function () {
    Promise.all([
      ready,
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var CartEvent = res[0];
      var cart = res[1];
      var deferred = CartEvent.createPromise();
      document.dispatchEvent(new CartEvent({ action: 'add', context: 'product', lines: [], promise: deferred.promise }));
      deferred.resolve({
        cart: CartEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'custom-order-box', itemCount: cart.item_count }
      });
    }).catch(function (err) { console.warn('Cart icon update failed', err); });
  });
})();
